import axios from "axios";
import { api } from "./helper";
import store from "../../store/store"

import { v4 as uuidv4 } from 'uuid';

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

export function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function CreateCourtEnforcement(item) {
  return client.post("CourtEnforcements/CreateCourtEnforcement", prepareDataRequest(item));
}

function UpdateEnforcementExecutor(item) {
  return client.post("CourtEnforcements/UpdateEnforcementExecutor", prepareDataRequest(item));
}

function GetCourtEnforcements(subrogationId) {
  const data = { subrogationId };
  return client.post("CourtEnforcements/GetCourtEnforcements/", prepareRequest(data));
}

function GetCourtEnforcementsByCourtCase(courtCaseId) {
  const data = { courtCaseId };
  return client.post("CourtEnforcements/GetCourtEnforcementsByCourtCase/", prepareRequest(data));
}

export {
    CreateCourtEnforcement,
    GetCourtEnforcements,
    UpdateEnforcementExecutor,
    GetCourtEnforcementsByCourtCase
}